import React from "react";
import { useAuth } from "../lib/auth";
import PlanBadge from "../components/PlanBadge";

export const WelcomeBanner = ({ subtitle, planOverride }) => {
  const { user } = useAuth();
  const first = (user?.name || "Agent").split(" ")[0];
  const hideSub = subtitle === null;
  return (
    <div className={hideSub ? "mb-6 lg:mb-8" : "mb-8 lg:mb-10"} data-testid="welcome-banner">
      <div className={`flex flex-wrap items-center gap-3 ${hideSub ? "" : "mb-2"}`}>
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">
          Welcome to Newground, {first} <span className="inline-block">👋</span>
        </h1>
        <PlanBadge plan={planOverride || user?.plan || "free"} size="lg" />
      </div>
      {!hideSub && (
        <p className="text-slate-500">
          {subtitle || "Your AI growth system is ready."}
        </p>
      )}
    </div>
  );
};

export default WelcomeBanner;
